import { useEffect } from 'react';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import cacheScope from '../common/utils/scope/index.tsx';

const CacheRegistry = () => {
	const accountIdLoggedInUser = useAccountId();

	useEffect(() => {
		cacheScope.set(accountIdLoggedInUser ?? 'anonymous');
	}, [accountIdLoggedInUser]);

	return null;
};

export default CacheRegistry;
